<template>
  <div>
    <Topo class="naoImprimir" :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <Migalha class="naoImprimir" v-if="$verificaPerfilCadastrador()" label="Histórico de Solicitações"> </Migalha>
    <Migalha class="naoImprimir" v-else label="Detalhe"></Migalha>


  <div class="flex-container">
    <!-- Esquerda -->
    <div class="flex-item-left"></div>

    <!-- Direita -->
    <div class="flex-item-right">
      <v-layout row wrap justify-end>
        <v-flex md4>
          <v-btn
            slot="activator" 
            color="primary" 
            class="mb-2">
              <v-tab 
                active-class
                v-bind:class="{ 'abaAtiva': abaAtiva=='tab-simpas'}"
                :href="'#'+abaAtiva"
                @click="setAba('tab-simpas')"
                >Extrato do fornecedor
              </v-tab>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout justify-end>   
        <v-flex md2>
          <v-btn
            slot="activator"
            color="primary"
            class="mb-2"
            @click="$router.go(-1)"
          >Voltar</v-btn>
        </v-flex>
        <v-flex md2>
          <v-btn 
            slot="activator" 
            color="primary" 
            class="mb-2"
            :href="this.url + this.numCNPJ"            
            target="_blank">
            Imprimir
            <v-icon dark right >
              print
            </v-icon>            
          </v-btn>
        </v-flex>      
      </v-layout>
    </div>
    <!-- / Direita -->
  </div>
    <v-tabs v-model="activeTab" slider-color="ss" class="abasStyle">
      <v-layout row wrap >
        <v-flex>
          <v-tab  
          active-class
          v-bind:class="{ 'abaAtiva': abaAtiva=='tab-comprasnet'}"
          class="naoImprimir"
          :href="'#'+abaAtiva"
          @click="setAba('tab-comprasnet')"
          >
            <strong>CAF-DIGITAL</strong>
          </v-tab>
        </v-flex >
      </v-layout>

      <!-- Retorno dos dados dentro de tab -->
      <v-tab-item value="tab-comprasnet">
        <v-form >
          <solicitacaoLista :numCgcFornecedorProp="numCgcFornecedor">
          </solicitacaoLista>
        </v-form>
      </v-tab-item>
      <v-tab-item value="tab-simpas">
        <fornecedorExtrato  @voltarhistorico="setAba('tab-comprasnet')" :numCgcFornecedorProp="numCgcFornecedor">
        </fornecedorExtrato>
      </v-tab-item>
    </v-tabs>
    <!-- / Retorno dos dados dentro de tab -->
  </div>
</template>

<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
import solicitacaoLista from "../../fornecedor/solicitacaoLista";
import fornecedorExtrato from "../../fornecedor/extrato/fornecedor-extrato";
//import Print from "vue-print-nb";
import CabecalhoImpressao from "../../../components/cabecalho-impressao";
import RodapeImpressao from "../../../components/rodape-impressao";
import dadosBasicos from "../../fornecedor/resumo/resumo-dados-basicos";
import Vue from "vue";

export default {
  name: "fornecedor-detalhe",
  mixins: [util],
  components: { /*Componentes utilizados*/
    Migalha,
    Topo,
    solicitacaoLista,
    fornecedorExtrato,
    dadosBasicos,
    CabecalhoImpressao,
    RodapeImpressao
  },
  created() /*Metodo de start do componente*/{
    this.numCgcFornecedor.texto = this.$route.params.numCgcFornecedor;
    this.numCNPJ = this.$route.params.numCgcFornecedor;
    // Vue.use(Print);
  },
  data() {//Declaracao de variaveis   
    return {    
     
      numCNPJ: null,
      cnpj: this.$route.params.numCgcFornecedor,
      //url: "http://localhost:85/Fornecedor/Certificado.asp?cnpj=",
      url: Vue.prototype.$baseURL == "https://www.comprasnetadm.ba.gov.br/api/" ? "https://comprasnet3.ba.gov.br/Fornecedor/Certificado.asp?cnpj=" : "https://hml3comprasnet.ba.gov.br/Fornecedor/Certificado.asp?cnpj=",
      activeTab: "tab-comprasnet",
      abaAtiva: "tab-comprasnet",
      numCgcFornecedor:{
        texto:"0123"
      }
    };
  },
  methods: {//Declaracao de todos os metodos
    setAba(abaAtiva) {
      this.abaAtiva = abaAtiva;
      this.activeTab = abaAtiva;
    },
   }
};
</script>

<style>
.abaAtiva a {
  color: #349fbe !important;
}

html {
  scroll-behavior: smooth;
}

.v-tabs__item:not(.v-tabs__item--active) {
  opacity: 1;
}

.flex-container {
  text-align: center;
}

.flex-item-right {
  width: 70%;
  position: relative;
  right: -460px;
  z-index: 1000;
}
</style>
